import React, { Component } from "react";
import { connect } from "react-redux";
import { pathToJS, dataToJS, firebaseConnect } from "react-redux-firebase";
import FontAwesome from "react-fontawesome";
import Dropdown, {
  DropdownTrigger,
  DropdownContent
} from "react-simple-dropdown";

import Select from "react-select";
import "react-select/dist/react-select.css";
import {
  BrowserRouter as Router,
  Route,
  Link,
  Redirect,
  withRouter
} from "react-router-dom";

import "./style.scss";
class Menu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sessions: []
    };
  }
  logout() {
    this.props.firebase.logout();
  }

  changeGroup(e) {
    e.preventDefault();
    this.context.router.transitionTo("/");
  }

  componentWillReceiveProps(props) {
    console.log(props);
    if (props.groups && props.profile) {
      this.state.session = props.groups[props.match.params.groupId];

      if (props.profile.role !== "admin") {
        this.state.sessions = Object.keys(props.groups)
          .map(key => ({ ...props.groups[key], _key: key }))
          .filter(group =>
            Object.keys(group.students)
              .map(key => group.students[key])
              .find(s => s.email === props.profile.email));
        if (
          props.groups[props.match.params.groupId] &&
          props.groups[props.match.params.groupId].students
        ) {
          this.state.user = Object.keys(
            props.groups[props.match.params.groupId].students
          )
            .map(key => ({
              ...props.groups[props.match.params.groupId].students[key],
              _key: key
            }))
            .find(s => s.email === props.profile.email);
        }

        if (!this.state.user) {
          this.state.redirect = this.state.sessions[0]._key;
          console.log("Redirect to ", this.state.redirect);
        } else {
          props.firebase.set(
            `/groups/${props.match.params.groupId}/students/${this.state.user._key}/uid`,
            props.auth.uid
          );
          console.log("SETTING UID", props.auth.uid);
        }
      } else {
        this.state.sessions = Object.keys(props.groups).map(key => ({
          ...props.groups[key],
          _key: key
        }));

        this.state.user = props.profile;
      }
    }
  }

  componentWillUnmount() {}

  render() {
    return (
      <div className="nav menu">
        {this.state.redirect &&
          <Redirect to={`/group/${this.state.redirect}`} />}
        {this.props.profile &&
          this.state.user &&
          <div>
            {this.state.sessions.length > 1
              ? <Dropdown>
                  <DropdownTrigger>
                    <h1>
                      {this.state.session ? this.state.session.name : "ERR"}
                      {" "}
                      {" "}
                      <span>
                        <FontAwesome name="caret-down" />
                      </span>
                    </h1>
                  </DropdownTrigger>
                  <DropdownContent className="card">
                    <ul>
                      {this.state.sessions.map(session => (
                        <Link to={`/group/${session._key}`} key={session._key}>
                          <li>{session.name}</li>
                        </Link>
                      ))}
                    </ul>
                  </DropdownContent>
                </Dropdown>
              : <h1>{this.state.session ? this.state.session.name : "ERR"}</h1>}
            <Dropdown>
              <DropdownTrigger>
                <h2>
                  <strong>
                    {this.state.user.firstName || "Admin"}
                    {" "}
                    {this.state.user.lastName} {" "}
                    <FontAwesome name="caret-down" />
                  </strong>
                  <br />
                  {this.props.profile.email}
                </h2>
              </DropdownTrigger>
              <DropdownContent className="card">
                <ul>
                  <li onClick={this.logout.bind(this)}>Logout</li>
                </ul>
              </DropdownContent>
            </Dropdown>

            {this.props.profile.role === "admin" &&
              <ul>
                <h3>Administrator Settings</h3>
                <Link to={`/group/${this.props.match.params.groupId}`}>
                  <li>Student Responses</li>
                </Link>
                <Link to={`/group/${this.props.match.params.groupId}/students`}>
                  <li>Enroll Students</li>
                </Link>
                <Link to={`/group/${this.props.match.params.groupId}/logs`}>
                  <li>Enable/Disable Logs</li>
                </Link>

                <h3>Edit Ignorance Logs</h3>
                {this.props.logs &&
                  Object.keys(this.props.logs)
                    .map((key, id) => ({ ...this.props.logs[key], _key: key }))
                    .filter(log => log.type === "log")
                    .sort((a, b) => a.order - b.order)
                    .map(log => (
                      <Link
                        to={
                          `/group/${this.props.match.params.groupId}/log/${log._key}/edit`
                        }
                        key={log._key}
                      >
                        <li
                          className={
                            this.props.match.params.logId == log._key
                              ? "active"
                              : ""
                          }
                        >
                          {log.title}
                        </li>
                      </Link>
                    ))}

                <h3>Edit Surveys</h3>
                {this.props.logs &&
                  Object.keys(this.props.logs)
                    .map((key, id) => ({ ...this.props.logs[key], _key: key }))
                    .filter(log => log.type === "survey")
                    .sort((a, b) => a.order - b.order)
                    .map(log => (
                      <Link
                        to={
                          `/group/${this.props.match.params.groupId}/log/${log._key}/edit`
                        }
                        key={log._key}
                      >
                        <li
                          className={
                            this.props.match.params.logId == log._key
                              ? "active"
                              : ""
                          }
                        >
                          {log.title}
                        </li>
                      </Link>
                    ))}

                <h3>Edit Resources</h3>
                {this.props.resources &&
                  Object.keys(this.props.resources)
                    .map((key, id) => ({
                      ...this.props.resources[key],
                      _key: key
                    }))
                    .map(resource => (
                      <Link
                        to={
                          `/group/${this.props.match.params.groupId}/resource/${resource._key}/edit`
                        }
                        key={resource._key}
                      >
                        <li
                          className={
                            this.props.match.params.resourceId == resource._key
                              ? "active"
                              : ""
                          }
                        >
                          {resource.title}
                        </li>
                      </Link>
                    ))}
              </ul>}
            {this.props.profile.role !== "admin" &&
              <ul>

                <h3>Ignorance Logs</h3>
                {this.props.logs &&
                  Object.keys(this.props.logs)
                    .map((key, id) => ({ ...this.props.logs[key], _key: key }))
                    .filter(log => log.type === "log")
                    .filter(
                      log =>
                        this.props.profile.role === "admin" ||
                        (this.props.groups[
                          this.props.match.params.groupId
                        ].logs &&
                          this.props.groups[
                            this.props.match.params.groupId
                          ].logs[log._key] &&
                          this.props.groups[
                            this.props.match.params.groupId
                          ].logs[log._key].isActive[
                            Object.keys(
                              this.props.groups[
                                this.props.match.params.groupId
                              ].students
                            )
                              .map(
                                key =>
                                  this.props.groups[
                                    this.props.match.params.groupId
                                  ].students[key]
                              )
                              .find(
                                s => s.email === this.props.profile.email
                              ).role
                          ])
                    )
                    .sort((a, b) => a.order - b.order)
                    .map(log => (
                      <Link
                        to={
                          `/group/${this.props.match.params.groupId}/log/${log._key}`
                        }
                        key={log._key}
                      >
                        <li
                          className={
                            this.props.match.params.logId == log._key
                              ? "active"
                              : ""
                          }
                        >
                          {log.title}
                        </li>
                      </Link>
                    ))}

                <h3>Surveys</h3>
                {this.props.logs &&
                  Object.keys(this.props.logs)
                    .map((key, id) => ({ ...this.props.logs[key], _key: key }))
                    .filter(log => log.type === "survey")
                    .filter(
                      log =>
                        this.props.profile.role === "admin" ||
                        (this.props.groups[
                          this.props.match.params.groupId
                        ].logs &&
                          this.props.groups[
                            this.props.match.params.groupId
                          ].logs[log._key] &&
                          this.props.groups[
                            this.props.match.params.groupId
                          ].logs[log._key].isActive[
                            Object.keys(
                              this.props.groups[
                                this.props.match.params.groupId
                              ].students
                            )
                              .map(
                                key =>
                                  this.props.groups[
                                    this.props.match.params.groupId
                                  ].students[key]
                              )
                              .find(
                                s => s.email === this.props.profile.email
                              ).role
                          ])
                    )
                    .sort((a, b) => a.order - b.order)
                    .map(log => (
                      <Link
                        to={
                          `/group/${this.props.match.params.groupId}/log/${log._key}`
                        }
                        key={log._key}
                      >
                        <li
                          className={
                            this.props.match.params.logId == log._key
                              ? "active"
                              : ""
                          }
                        >
                          {log.title}
                        </li>
                      </Link>
                    ))}
                <h3>Resources</h3>
                {this.props.resources &&
                  Object.keys(this.props.resources)
                    .map((key, id) => ({
                      ...this.props.resources[key],
                      _key: key
                    }))
                    .filter(
                      resource =>
                        this.props.profile.role === "admin" ||
                        this.props.resources[resource._key].isActive[
                          Object.keys(
                            this.props.groups[
                              this.props.match.params.groupId
                            ].students
                          )
                            .map(
                              key =>
                                this.props.groups[
                                  this.props.match.params.groupId
                                ].students[key]
                            )
                            .find(
                              s => s.email === this.props.profile.email
                            ).role
                        ]
                    )
                    .map(resource => (
                      <Link
                        to={
                          `/group/${this.props.match.params.groupId}/resource/${resource._key}`
                        }
                        key={resource._key}
                      >
                        <li
                          className={
                            this.props.match.params.resourceId == resource._key
                              ? "active"
                              : ""
                          }
                        >
                          {resource.title}
                        </li>
                      </Link>
                    ))}
              </ul>}
            <br /><br /><br />
          </div>}
      </div>
    );
  }
}

export default withRouter(
  connect(({ firebase }, router) => {
    return {
      groups: dataToJS(firebase, "/groups"),
      resources: dataToJS(firebase, "/resources"),
      logs: dataToJS(firebase, "/logs"),
      auth: pathToJS(firebase, "/auth"),
      profile: pathToJS(firebase, "/profile")
    };
  })(firebaseConnect(["/groups", "/logs", "/resources"])(Menu))
);



// WEBPACK FOOTER //
// ./src/containers/menu/index.js